import { InsightRule } from "../../gateway/Insight/InsightRule";
import { Serie } from "../../gateway/Serie/Serie";
import { Visualization } from "../../gateway/Visualization/Visualization";
import { DataManagerService } from "./DataManagerService";
export class GoalsDataService {
    constructor() {
        this.InsightRule = new InsightRule();
        this.DataManagerService = new DataManagerService();
        this.Visualization = new Visualization();
        this.Serie = new Serie();
    }

    async save({ goalsRules, date, company, source, projection, budget }) {
        const rulesIds = [];
        const goalsInput = goalsRules.map((r) => {
            if (r.sources.includes("accounting")) rulesIds.push(r.referenceId);
            else rulesIds.push(r._id);
            return {
                ruleId: r._id,
                value: r.form.value,
                operationConditional: r.form.goal
            };
        });

        await this.InsightRule.updateGoals(goalsInput);
        const currentDate = {
            year: date?.getUTCFullYear(),
            month: date?.getUTCMonth() + 1
        };
        await this.DataManagerService.managerPointsCalc({
            company: company,
            scenarioIdBase: "ORIGINAL",
            scenarioIdCompare: "ORIGINAL",
            currentDate,
            goals: true,
            source: source,
            projection,
            goalsIds: rulesIds,
            budget
        });
    }

    async getListByGoalsIds(goalsIds) {
        if (!goalsIds?.length) return [];
        const insightRule = await this.InsightRule.getByIds(goalsIds);

        let list = [];
        for (let rule of insightRule?.rules) {
            const ruleDiagnosis = this._getRuleDiagnosisGood(rule);

            list.push({
                _id: rule._id,
                name: rule.name,
                explanation: ruleDiagnosis?.speech?.variables?.explanation
            });
        }

        return list;
    }

    /**
     * Metodo responsavel por pegar as regras e tornar listavel para compoentes
     * Recebe as series da visualizations ja com os objetivos
     */
    async getList({ series, visualization }) {
        const goalsIds = [];

        series.forEach((s) => {
            if (s.metadata?.origin === "goals") {
                goalsIds.push(s._id);
            }
        });

        const insightRule = await this.InsightRule.getByIds(goalsIds);

        let list = [];
        if (!insightRule?.rules?.length) return [];
        for (let i = 0; i < insightRule.rules.length; i++) {
            const ruleDiagnosis = this._getRuleDiagnosisGood(
                insightRule.rules[i]
            );
            insightRule.rules[i].goodDiagnosis = ruleDiagnosis;
            insightRule.rules[i].form = this._getFieldsInUse(
                visualization?.goals,
                insightRule.rules[i]
            );
            list.push(insightRule.rules[i]);
        }

        return list;
    }

    _getRuleDiagnosisGood(rule) {
        if (!rule.insights) return;
        const diagnosis = rule.insights.find((s) => s.diagnosis === "good");
        return diagnosis;
    }

    _getFieldsInUse(goals, insightRule) {
        const goalRule = goals.find((g) => {
            if (insightRule.sources[0] === "accounting")
                return insightRule.referenceId === g.r;
            return insightRule._id === g.r;
        });
        return {
            _id: goalRule.r,
            goal: insightRule.goodDiagnosis?.operationConditional,
            value: insightRule.series.defaultTarget?.m,
            unit: insightRule.series.defaultTarget?.unit
        };
    }

    async generateGoals({ source, accountingEntity, companyData }) {
        if (accountingEntity.hasCompanyAnalysisPlus()) {
            if (!companyData.preferences?.goals?.sources?.includes(source)) {
                console.info("GERANDO OBJETIVOS DO: ", source);
                await this.Visualization.setGoals({
                    accountingId: accountingEntity.props._id,
                    companyId: companyData._id,
                    source
                });
                return true;
            }
            return false;
        }
        return false;
    }

    async getSerieByVisualization({
        visualizationDrillDown,
        currentVisualization,
        companyData,
        scenarioIdBase,
        scenarioIdCompare,
        currentDate,
        projection
    }) {
        const drillDownSerieId = visualizationDrillDown.series[0];
        let goalSerie = false;
        if (currentVisualization.goals)
            goalSerie = currentVisualization.goals.find(
                (serie) => serie.s === drillDownSerieId
            );
        if (goalSerie) return goalSerie;
        const source = currentVisualization.sources[0];
        const goalSerieByDescription = this.Serie.findOneCollection({
            "metadata.origin": "goals",
            description: visualizationDrillDown.name,
            sources: source
        });
        if (goalSerieByDescription) {
            const goalId =
                source === "accounting"
                    ? goalSerieByDescription.referenceId
                    : goalSerieByDescription._id;
            await this.DataManagerService.managerPointsCalc({
                company: companyData,
                scenarioIdBase,
                scenarioIdCompare,
                currentDate,
                goals: true,
                source: source,
                projection,
                goalsIds: [goalId]
            });
            return {
                s: drillDownSerieId,
                r: goalId
            };
        }
        return false;
    }
}
